// extracted by mini-css-extract-plugin
export default {"toast":"toast_toast__ew59j","shown":"toast_shown__1STIX"};